import axios from "axios";

/**
 * component_contents.json からID=13のデータを取得
 * @returns {Promise<Array<{url: string, text: string, date?: string, data?: string, new?: boolean}>>}
 */
export async function fetchSimbaNews() {
  try {
    const res = await axios.get(__COMPONENT_CONTENTS_URL__, {
      params: { t: Date.now() }, // キャッシュバスター
    });

    const data = res?.data;
    if (!Array.isArray(data)) {
      console.warn("[component_contents] JSONが配列ではありません");
      return [];
    }

    // ID=13のデータを取得
    const simbaLP = data.find((item) => item.id === 13);
    if (!simbaLP || !simbaLP.json_data) {
      console.warn("[component_contents] ID=13が見つかりません");
      return [];
    }

    // json_dataをパース
    const newsItems = JSON.parse(simbaLP.json_data);
    return Array.isArray(newsItems) ? newsItems : [];
  } catch (err) {
    console.error("[component_contents] 取得に失敗:", err);
    return [];
  }
}
